import '@/i18n'
import '@/config/amplify'
import '@aws-amplify/ui-react/styles.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { AntdProvider } from '@/config/antd'
import { ErrorBoundary } from '@/widgets/common'
import { ToastProvider } from '@/widgets/common'
import './index.css'
import App from './App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <AntdProvider>
        <BrowserRouter>
          <ToastProvider>
            <App />
          </ToastProvider>
        </BrowserRouter>
      </AntdProvider>
    </ErrorBoundary>
  </StrictMode>,
)
